<template>
    <div class="content mt20 bgfff">
        <div class="bd clearfix">
            <button class="btn btn-blue fl" @click="addUser"><i class="icons add-blue-icon"></i>添加用户</button>
            <div class="fr">
                <div class="search fl">
                    <input type="text" class="input-text" name="search" placeholder="请输入用户名/手机号" v-model="msg" @keyup="searchButton">
                </div>
                <button class="btn btn-blue" @click="searchButton"><i class="icons search-icon"></i></button>
            </div>
        </div>
        <div class="table-warp mt15">
            <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="20%">
                    <col width="20%">
                    <col width="20%">
                    <col width="20%">
                    <col width="15%">
                </colgroup>
                <thead>
                    <tr>
                        <th>用户名</th>
                        <th>手机号</th>
                        <th>加入时间</th>
                        <th>用户组</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="" v-if="nodata">
                        <td colspan="5"><div class="no-data" ><span class="text">没有数据哦...</span></div></td>
                    </tr>
                    <tr v-for="(item,index) in list" :key="index">
                        <td>
                            {{item.username}}
                        </td>
                        <td>{{item.mobile}}</td>
                        <td>
                            {{item.createdAt}}
                        </td>
                        <td>
                            {{item.levelName}}
                        </td>
                        <td>
                            <div class="profile-btn" v-if="item.isBuy!=1">
                                <div class="del-content fl">
                                   <a href="javascript:void(0);" @click="delUser(index,item.id)" class="del color-red">删除</a>
                                   <div class="delModal" v-show="index == i">
                                        <div class="delModal-c">
                                            <div class="ar"><i class="icons icon-close" @click="close(index)"></i></div>
                                            <div class="fs14 color-blue ac"><i class="icons icon-warn"></i>确定删除这条账号数据吗？</div>
                                            <div class="btn mt10 ar">
                                                <button class="btn btn-sure" @click="del(index,item.id)">确定</button>
                                                <button class="btn btn-cancel ml5" @click="close(index)">取消</button>
                                            </div>
                                            <div class="bottom"></div>
                                        </div>
                                    </div>
                                </div>
                                <router-link class="edit color-blue" :to="{path:'/userManagement/userPower',query:{id:item.id,type:item.type,pages:currentPage}}">权限调整</router-link>
                                
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- 分页 -->
            <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
        </div>
         <!-- 提示弹框 -->
        <Dialog ref="addDialog" type="normal" title="添加用户" width="422" :callback="addModal">
            <div slot="mdBox">
                <div class="adduser">
                    <div class="form-group clearfix">
                        <label class="control-label w">用户组：</label>
                        <div class="clearfix fl">
                            <div class="radio radio1 fl">
                                <input type="radio" v-model="sel" value="1" class="radio-i">
                                <span class="radio-ico"></span>
                                
                            </div>
                            <span>管理员</span>
                        </div>
                        <div class="clearfix  ml30 fl">
                            <div class="radio radio1 fl">
                                <input type="radio" v-model="sel" value="2" class="radio-i">
                                <span class="radio-ico"></span>
                            </div>
                            <span>普通用户</span>
                        </div>
                    </div>
                    <div class="form-group mt10 clearfix">
                        <label class="control-label w mt5">用户名：</label>
                        <div class="checkbox fl">
                            <input type="text" class="input-text w298" v-model="userPhone" placeholder="请输入清博账号或手机号" />
                            <p v-html="tipsText" class="color-red fs12 mt5" ></p>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '@/components/dialog'
export default {
    components: {Page,Dialog},
    data() {
        return {
           msg:'', //搜索词
           list:[],//用户列表
           tipsHtml:'',//添加用户弹框
           userPhone:'',//弹框用户名
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:10,//总条数
           sel:1,//管理员
           userPhone:'',//清博账号或手机号
           tipsText:'',//清博账号提示
           isActive:false,
           i:-1,//index
           nodata:false,
        }
    },
    mounted() {
        let that = this;
		
		if(that.$route.query.pages==undefined){
			that.currentPage = that.currentPage;
			
		}else{
			that.currentPage = parseInt(that.$route.query.pages)
		}
        that.dataAjax();
    },
    created() {
		
    },
    methods: {
         del(index,id){
             this.i = -1;
             let that = this;
             //删除当前行
            that.$api.post('/user/del',{id:id},r=>{
                  that.$parent.returnCode(r,function(){
                  that.dataAjax(0);
              });
            });
        },
        close(index){//删除弹框点击叉叉关闭
            this.i = -1;
        },
        delUser(index,id){//点击删除弹框
            let that =this;
            that.i = index;
        },
        addUser(){//新增用户
            let that = this;
            that.$refs.addDialog.showMaskFun();
            that.userPhone='';
            that.tipsText='';
        },
        addModal(){ //新增用户确定按钮
            let that = this;
             if(that.userPhone==''){
                that.tipsText = '请输入清博账号或手机号!'
                return false;
            }else{
                that.tipsText='';
            }
            that.$api.post('/user/add',{level:that.sel,username:that.userPhone},r=>{
                  that.$parent.returnCode(r,function(){
                  that.dataAjax(0);
              })
          })
            that.$refs.addDialog.closeMask();
        },
        searchButton(){//搜索
            this.currentPage = 1;
            this.dataAjax(0);
            
        },
        getTableData(){//分页
			let that =this;
			that.$router.push({
                path: '/userManagement',
                query: {
                    pages: that.currentPage,
                }
            });
            that.dataAjax();
        },
        dataAjax(cpage){ //用户列表
           let that = this;
            if(cpage==0){
               that.currentPage =1;
            }
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('user/getlist',{search:that.msg,page:that.currentPage,pagesize:that.limit},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.list=r.data.data;
					that.totalCount = r.data.total;
                    if(that.list.length<=0){
                       that.nodata = true;
                    }else{
                       that.nodata = false;
                       
                    }
                })
          })
           
       }
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/userManagement/userManagement.vue